module.exports = {"130107001":"矿市街道","130107002":"四微街道","130107100":"贾庄镇","130107101":"凤山镇","130107200":"横涧乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130107.json
// module id = 60
// module chunks = 0